import styled from 'styled-components'
import Form from 'components/Form'

export const StyledForm = styled(Form)`
  margin-top: 24px;
`
